import DashboardStats from "@/components/dashboard/DashboardStats";
import DataPeriodCard from "@/components/dashboard/DataPeriodCard";
import GettingStartedCard from "@/components/dashboard/GettingStartedCard";
import QuickActions from "@/components/dashboard/QuickActions";
import DataManagementCard from "@/components/dashboard/DataManagementCard";

function hasAnyData(s) {
  return !!s && ((s.groups || 0) > 0 || (s.ledgers || 0) > 0 || (s.accounts || 0) > 0 || (s.vouchers || 0) > 0);
}

/**
 * Dashboard — thin orchestrator composing 5 small widgets.
 * Each widget is in ./dashboard/*.jsx and is independently testable.
 */
export default function Dashboard({ summary, loading, onNavigate, onRefresh, companyContext }) {
  const companyId = companyContext?.companyId || "default";

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64" data-testid="dashboard-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  const dataPresent = hasAnyData(summary);

  return (
    <div data-testid="dashboard">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900" data-testid="dashboard-title">
          Dashboard
        </h1>
        <p className="text-sm text-slate-500 mt-1">Overview of your financial data</p>
      </div>

      <DashboardStats summary={summary} />
      <DataPeriodCard dateRange={summary?.date_range} />

      {!dataPresent && <GettingStartedCard />}
      {dataPresent && (
        <>
          <QuickActions onNavigate={onNavigate} />
          <div className="mt-4">
            <DataManagementCard companyId={companyId} onRefresh={onRefresh} />
          </div>
        </>
      )}
    </div>
  );
}
